module.exports = "/_next/static/images/OctoDiagram-xs@2x-512afe893a936259e79f364007d1e2e0.webp";